'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
class Init {
    constructor() {
        this.viewTest();
    }
    viewTest() {
        console.log('init');
    }
}
exports.Init = Init;
exports.default = Init;
